module.exports = __webpack_public_path__ + "img/dg1.26e2aa45.png";